<template>
  <div class="homeCheckOut overflow-hidden">
    <div class="w-100">
      <builder_body />
    </div>
  </div>
</template>
<script>
import builder_body from '@/components/builder_body'
export default {
  el: '#FloorPlanCheckout',
  name: "floorplans-mainapp",
  components: {
    builder_body
  },
  created() {
    this.$store.dispatch('retriveFloorPlans')
    console.log(window)
  }

}

</script>
<style lang="scss">
.homeCheckOut{
  //width: 850px;
/*@media screen and (max-width: 850px){
  width: 100%;
}*/
}
* {
  -webkit-font-smoothing: antialiased;
}
.points ul {
  padding: 0 20px;
}

.w-100{
  width: 100%;
}
</style>
<style>

</style>

